import { t } from 'i18next';
import { FileUpload } from 'primereact/fileupload';

import { useState } from "react";


function FileEditor({
    data,
    label,
    placeholder,
    // onChange,
    onBlur,
    message,
    attr,
    options,
    accept,
    ...arr
}) {

    const [value, setValue] = useState(data?.[attr])
    function onChange(e) {
        setValue(e.target.files[0])
        onBlur(e, attr, e.target.files[0]);
    }

    return (<>
        <div className="flex justify-content-center">
            <div className="editor">

                <div className="file_upload">
                    <input type="file" className='file_upload_inp' onChange={onChange} accept={accept ?? "application/pdf, application/vnd.ms-excel"} />
                    <label htmlFor="" className="file_upload_label">{t("download")}</label>
                    <p className='file_upload_link'>{value?.name}</p>
                </div>

            </div>
        </div>
    </>);
}

export default FileEditor;